import { post, get } from './http'

//获取体育教材列表
export function getMaterialList(page, limit, typeIds,courseIds) {
  return post('/tyapi/pc/teaching/getMaterialList', {
    page: page,
    limit: limit,
    typeIds: typeIds, //"231,231格式"
    courseIds:courseIds
  })
}

//获取体育教材详情
export function getMaterialInfo(materialId) {
  return post('/tyapi/pc/teaching/getMaterialInfo', {
    id: materialId,
  })
}

//获取教材分类信息
export function getMaterialType() {
  return get('/tyapi/pc/teaching/getMaterialType', {})
}

//获取所属课程分类
export function getCourseType() {
  return get('/tyapi/pc/teaching/getCourseType', {})
}
